// Feature-Aware Router Component
// Only renders routes that are available in the current build target

import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

// Import all possible components
import DefaultLandingPage from './DefaultLandingPage';
import NotFoundPage from './common/NotFoundPage';
import Payments from '../../pages/facturation/Payments';
import FacturationAlertsPage from '../../pages/facturation/FacturationAlertsPage';
import InventaireAlertsPage from '../../pages/inventaire/InventaireAlertsPage';
import DocumentCreation from '../../pages/facturation/invoice/DocumentCreation';
import EmployeesPage from '../../pages/ressources-humaines/EmployeesPage';
import EmployeeInfoManagementPage from '../../pages/ressources-humaines/EmployeeInfoManagementPage';
import DepartmentsPage from '../../pages/ressources-humaines/DepartmentsPage';
// import DeliveryTransportPage from './DeliveryTransportPage'; // DELETED
import Products from '../../pages/facturation/Products';
import ArticlesMainPage from '../../pages/articles/ArticlesMainPage';
import Services from '../../pages/facturation/Services';
import Categories from '../../pages/facturation/Categories';
import ArchivesFacturation from '../../pages/facturation/ArchivesFacturation';
import FacturationSectionArchivesPage from '../../pages/facturation/FacturationSectionArchivesPage';
import Settings from './settings/Settings';
import Profile from './profile/Profile';
import SaudiPlaceholderPage from '../../products/saudi/pages/SaudiPlaceholderPage';
import AnalysesRapportsFacturation from '../../pages/facturation/AnalysesRapportsFacturation';
import BillingDashboardPage from '../../pages/facturation/BillingDashboardPage';
import ComptabiliteMainPage from '../../pages/comptabilite/ComptabiliteMainPage';

// Advanced/Inventory features
import CrmMainPage from '../../pages/crm/CrmMainPage';

// Other advanced pages
import TimeTrackingMainPage from '../../pages/pointage/TimeTrackingMainPage';
import DemandesCongesPage from '../../pages/pointage/DemandesCongesPage';
import HorairesTravailPage from '../../pages/pointage/HorairesTravailPage';
import CalendrierFeriesPage from '../../pages/pointage/CalendrierFeriesPage';
import JustificatifsPage from '../../pages/pointage/JustificatifsPage';
import RecuperationsPage from '../../pages/pointage/RecuperationsPage';
import ProfilsHorairesPage from '../../pages/pointage/ProfilsHorairesPage';
import ZonesTravailPage from '../../pages/pointage/ZonesTravailPage';
import AffectationsEquipesPage from '../../pages/pointage/AffectationsEquipesPage';
import SalariesMainPage from '../../pages/salaires/SalariesMainPage';
import TreasuryMainPage from '../../pages/caisse/TreasuryMainPage';
import BankingMainPage from '../../pages/banque/BankingMainPage';
import FacturationConfigPage from '../../pages/facturation/FacturationConfigPage';
import FacturiersPage from '../../pages/facturation/FacturiersPage';
import ClientsPage from '../../pages/facturation/ClientsPage';
import RelancesPage from '../../pages/facturation/RelancesPage';
import AlertesEcheancesPage from '../../pages/facturation/AlertesEcheancesPage';
import FacturesRecurrentesPage from '../../pages/facturation/FacturesRecurrentesPage';
import ImpayesCreancesPage from '../../pages/facturation/ImpayesCreancesPage';
import ConditionsPaiementPage from '../../pages/facturation/ConditionsPaiementPage';
import NumerotationPage from '../../pages/facturation/NumerotationPage';
import ModelesMentionsPage from '../../pages/facturation/ModelesMentionsPage';
import FacturationElectroniquePage from '../../pages/facturation/FacturationElectroniquePage';
// import ManagementConfigPage from '../../pages/gestion/ManagementConfigPage'; // REMOVED
import InventoryConfigPage from '../../pages/inventaire/InventoryConfigPage';
import AnalysesRapportsInventaire from '../../pages/inventaire/AnalysesRapportsInventaire';
import InventoryDashboardPage from '../../pages/inventaire/InventoryDashboardPage';
import AchatsMainPage from '../../pages/achats/AchatsMainPage';
import PrixRemisesPage from '../../pages/ventes/PrixRemisesPage';
import LivraisonsVentesPage from '../../pages/ventes/LivraisonsVentesPage';
import VentesAlertsPage from '../../pages/ventes/VentesAlertsPage';
import LivreDesVentesPage from '../../pages/ventes/LivreDesVentesPage';
import CommandesClientsPage from '../../pages/ventes/CommandesClientsPage';
import RetoursVentesPage from '../../pages/ventes/RetoursVentesPage';
import PipelineCommercialPage from '../../pages/ventes/PipelineCommercialPage';
import PrevisionsVentesPage from '../../pages/ventes/PrevisionsVentesPage';
import CommissionsPage from '../../pages/ventes/CommissionsPage';
import AnalysesRapportsVentesPage from '../../pages/ventes/AnalysesRapportsVentesPage';
import SalesDashboardPage from '../../pages/ventes/SalesDashboardPage';
import VentesConfigPage from '../../pages/ventes/VentesConfigPage';
import InventairePhysiquePage from '../../pages/inventaire/InventairePhysiquePage';
import EmplacementsZonesPage from '../../pages/inventaire/EmplacementsZonesPage';
import LotsTracabilitePage from '../../pages/inventaire/LotsTracabilitePage';
import PickingPreparationPage from '../../pages/inventaire/PickingPreparationPage';
import ReapprovisionnementPage from '../../pages/inventaire/ReapprovisionnementPage';
import AlertesSeuilsStockPage from '../../pages/inventaire/AlertesSeuilsStockPage';
import StockReservationPage from '../../pages/inventaire/StockReservationPage';
import HrMainPage from '../../pages/ressources-humaines/HrMainPage';
import ApprobationsMainPage from '../../pages/approbations/ApprobationsMainPage';
import EmployeePortalMainPage from '../../pages/employee-portal/EmployeePortalMainPage';
import DepartsPage from '../../pages/ressources-humaines/DepartsPage';
import SanctionsPage from '../../pages/ressources-humaines/SanctionsPage';
import AccidentsPage from '../../pages/ressources-humaines/AccidentsPage';
import { HRProvider } from '../../core/contexts/HRContext';
import WarehousesPage from '../../pages/inventaire/WarehousesPage';
import ValuationPage from '../../pages/inventaire/ValuationPage';
import TransfertsPage from '../../pages/inventaire/TransfertsPage';
import AjustementsPage from '../../pages/inventaire/AjustementsPage';
import MouvementsStockPage from '../../pages/inventaire/MouvementsStockPage';
import InventaireDocumentCreation from '../../pages/inventaire/InventaireDocumentCreation';
import ArchivesInventaire from '../../pages/inventaire/ArchivesInventaire';
import TreasuryPage from '../../pages/caisse/TreasuryPage';

import { AIAgentWorkspacePage } from '../../ai-agent';
import { AGENT_MODULE_ROUTES } from '../../ai-agent/config/agentModuleRegistry';

// Protected route component - ALL FEATURES ENABLED (No license check)
const ProtectedRoute = ({ component: Component, featureRoute, ...props }) => {
  // All features are now enabled - no license restrictions
  return <Component {...props} />;
};

const FeatureAwareRouter = () => {
  return (
    <Routes>
      {/* Core routes */}
      <Route path="/" element={<DefaultLandingPage />} />

      <Route path="/agent" element={<Navigate to="/facturation/agent" replace />} />
      <Route path="/ia" element={<Navigate to="/facturation/agent" replace />} />
      <Route path="/ia/*" element={<Navigate to="/facturation/agent" replace />} />

      {AGENT_MODULE_ROUTES.map(({ path, featureRoute }) => (
        <Route
          key={path}
          path={path}
          element={
            <ProtectedRoute component={AIAgentWorkspacePage} featureRoute={featureRoute} />
          }
        />
      ))}
      
      <Route path="/overview" element={<Navigate to="/document-creation" replace />} />
      
      <Route path="/bord-inventaire" element={<Navigate to="/warehouses" replace />} />

      <Route 
        path="/bord-inventaire/alertes" 
        element={<ProtectedRoute component={InventaireAlertsPage} featureRoute="/dashboard" />} 
      />
      
      <Route path="/dashboard" element={<Navigate to="/document-creation" replace />} />
      
      <Route 
        path="/dashboard/alertes" 
        element={<ProtectedRoute component={FacturationAlertsPage} featureRoute="/bord-facturation" />} 
      />
      
      <Route
        path="/facturation/dashboard"
        element={<ProtectedRoute component={BillingDashboardPage} featureRoute="/bord-facturation" />}
      />

      <Route 
        path="/facturation/analyses-rapports" 
        element={<ProtectedRoute component={AnalysesRapportsFacturation} featureRoute="/bord-facturation" />} 
      />
      
      <Route 
        path="/facturation/config" 
        element={<ProtectedRoute component={FacturationConfigPage} featureRoute="/bord-facturation" />} 
      />
      
      <Route 
        path="/facturation/facturiers" 
        element={<ProtectedRoute component={FacturiersPage} featureRoute="/facturiers" />} 
      />
      
      <Route
        path="/relation-client/clients"
        element={<ProtectedRoute component={ClientsPage} featureRoute="/relation-client/clients" />}
      />

      <Route
        path="/facturation/clients-only"
        element={<Navigate to="/relation-client/clients" replace />}
      />
      
      <Route 
        path="/facturation/relances" 
        element={<ProtectedRoute component={RelancesPage} featureRoute="/facturation" />} 
      />

      <Route
        path="/facturation/alertes"
        element={<ProtectedRoute component={AlertesEcheancesPage} featureRoute="/facturation/alertes" />}
      />
      <Route
        path="/facturation/factures-recurrentes"
        element={<ProtectedRoute component={FacturesRecurrentesPage} featureRoute="/facturation/factures-recurrentes" />}
      />
      <Route
        path="/facturation/impayes"
        element={<ProtectedRoute component={ImpayesCreancesPage} featureRoute="/facturation/impayes" />}
      />
      <Route
        path="/facturation/conditions-paiement"
        element={<ProtectedRoute component={ConditionsPaiementPage} featureRoute="/facturation/conditions-paiement" />}
      />
      <Route
        path="/facturation/numerotation"
        element={<ProtectedRoute component={NumerotationPage} featureRoute="/facturation/numerotation" />}
      />
      <Route
        path="/facturation/modeles-mentions"
        element={<ProtectedRoute component={ModelesMentionsPage} featureRoute="/facturation/modeles-mentions" />}
      />
      <Route
        path="/facturation/facturation-electronique"
        element={<ProtectedRoute component={FacturationElectroniquePage} featureRoute="/facturation/facturation-electronique" />}
      />
      
      {/* ACHATS MODULE */}
      <Route 
        path="/achats/*" 
        element={<ProtectedRoute component={AchatsMainPage} featureRoute="/achats" />} 
      />
      
      {/* VENTES MODULE */}
      <Route path="/ventes" element={<Navigate to="/ventes/dashboard" replace />} />
      <Route
        path="/ventes/dashboard"
        element={<ProtectedRoute component={SalesDashboardPage} featureRoute="/ventes" />}
      />
      <Route 
        path="/ventes/alertes" 
        element={<ProtectedRoute component={VentesAlertsPage} featureRoute="/ventes" />}
      />
      <Route 
        path="/ventes/livre-des-ventes" 
        element={<ProtectedRoute component={LivreDesVentesPage} featureRoute="/ventes/livre-des-ventes" />} 
      />
      <Route 
        path="/ventes/prix-remises" 
        element={<ProtectedRoute component={PrixRemisesPage} featureRoute="/ventes/prix-remises" />} 
      />
      <Route 
        path="/ventes/livraisons" 
        element={<ProtectedRoute component={LivraisonsVentesPage} featureRoute="/ventes/livraisons" />} 
      />
      <Route 
        path="/ventes/commandes" 
        element={<ProtectedRoute component={CommandesClientsPage} featureRoute="/ventes/commandes" />} 
      />
      <Route 
        path="/ventes/retours" 
        element={<ProtectedRoute component={RetoursVentesPage} featureRoute="/ventes/retours" />} 
      />
      <Route 
        path="/ventes/pipeline" 
        element={<ProtectedRoute component={PipelineCommercialPage} featureRoute="/ventes/pipeline" />} 
      />
      <Route 
        path="/ventes/previsions" 
        element={<ProtectedRoute component={PrevisionsVentesPage} featureRoute="/ventes/previsions" />} 
      />
      <Route 
        path="/ventes/commissions" 
        element={<ProtectedRoute component={CommissionsPage} featureRoute="/ventes/commissions" />} 
      />

      <Route
        path="/ventes/analyses-rapports"
        element={<ProtectedRoute component={AnalysesRapportsVentesPage} featureRoute="/ventes" />}
      />
      <Route
        path="/ventes/config"
        element={<ProtectedRoute component={VentesConfigPage} featureRoute="/ventes/config" />}
      />

      <Route 
        path="/inventaire/inventaire-physique" 
        element={<ProtectedRoute component={InventairePhysiquePage} featureRoute="/inventory" />} 
      />
      <Route 
        path="/inventaire/emplacements-zones" 
        element={<ProtectedRoute component={EmplacementsZonesPage} featureRoute="/inventory" />} 
      />
      <Route 
        path="/inventaire/lots-tracabilite" 
        element={<ProtectedRoute component={LotsTracabilitePage} featureRoute="/inventory" />} 
      />
      <Route 
        path="/inventaire/picking-preparation" 
        element={<ProtectedRoute component={PickingPreparationPage} featureRoute="/inventory" />} 
      />
      <Route 
        path="/inventaire/reapprovisionnement" 
        element={<ProtectedRoute component={ReapprovisionnementPage} featureRoute="/inventory" />} 
      />
      <Route 
        path="/inventaire/alertes-seuils" 
        element={<ProtectedRoute component={AlertesSeuilsStockPage} featureRoute="/inventory" />} 
      />
      <Route 
        path="/inventaire/reservations" 
        element={<ProtectedRoute component={StockReservationPage} featureRoute="/inventory" />} 
      />
      
      {/* REMOVED: Management Config */}
      
      <Route 
        path="/inventaire/config" 
        element={<ProtectedRoute component={InventoryConfigPage} featureRoute="/inventaire" />} 
      />
      
      <Route
        path="/inventaire/dashboard"
        element={<ProtectedRoute component={InventoryDashboardPage} featureRoute="/inventaire" />}
      />

      <Route
        path="/inventaire/analyses-rapports"
        element={<ProtectedRoute component={AnalysesRapportsInventaire} featureRoute="/inventaire" />} 
      />
      
      {/* Inventaire Document Creation - 5 LOGISTIQUE documents */}
      <Route 
        path="/inventaire/document-creation" 
        element={<ProtectedRoute component={InventaireDocumentCreation} featureRoute="/inventaire" />} 
      />

      <Route 
        path="/inventaire/archives" 
        element={<ProtectedRoute component={ArchivesInventaire} featureRoute="/inventaire" />} 
      />
      
      <Route 
        path="/document-creation" 
        element={<ProtectedRoute component={DocumentCreation} featureRoute="/documents/new" />} 
      />
      
      <Route 
        path="/creer-un-document" 
        element={<ProtectedRoute component={DocumentCreation} featureRoute="/documents/new" />} 
      />

      {/* Employee Management - REMOVED: Use RH module instead */}
      
      <Route 
        path="/employees/*" 
        element={<ProtectedRoute component={EmployeesPage} featureRoute="/employees-management" />} 
      />
      
      <Route 
        path="/employee-info-management" 
        element={<ProtectedRoute component={EmployeeInfoManagementPage} featureRoute="/employees-management" />} 
      />

      {/* Products, Services & Categories */}
      <Route
        path="/articles/*"
        element={<ProtectedRoute component={ArticlesMainPage} featureRoute="/articles/equipements" />}
      />

      <Route 
        path="/products" 
        element={<ProtectedRoute component={Products} featureRoute="/products" />} 
      />
      
      <Route 
        path="/services" 
        element={<ProtectedRoute component={Services} featureRoute="/services" />} 
      />
      
      <Route 
        path="/categories" 
        element={<ProtectedRoute component={Categories} featureRoute="/categories" />} 
      />

      {/* Financial Management */}
      <Route 
        path="/payments" 
        element={<ProtectedRoute component={Payments} featureRoute="/payments" />} 
      />
      
      {/* TreasuryPage moved to /treasury/accounts */}
      <Route 
        path="/treasury/accounts" 
        element={<ProtectedRoute component={TreasuryPage} featureRoute="/finances" />} 
      />
      
      <Route 
        path="/comptabilite/*" 
        element={<ProtectedRoute component={ComptabiliteMainPage} featureRoute="/comptabilite" />}
      />

      {/* Archives */}
      <Route 
        path="/archives" 
        element={<ProtectedRoute component={ArchivesFacturation} featureRoute="/archives" />} 
      />

      {/* Facturation section archives (Vue Générale per document family) */}
      <Route
        path="/facturation/demande-prix"
        element={<ProtectedRoute component={FacturationSectionArchivesPage} featureRoute="/facturation/demande-prix" />}
      />
      <Route
        path="/facturation/devis-proformas"
        element={<ProtectedRoute component={FacturationSectionArchivesPage} featureRoute="/facturation/devis-proformas" />}
      />
      <Route
        path="/facturation/bons-commande"
        element={<ProtectedRoute component={FacturationSectionArchivesPage} featureRoute="/facturation/bons-commande" />}
      />
      <Route
        path="/facturation/receptions"
        element={<ProtectedRoute component={FacturationSectionArchivesPage} featureRoute="/facturation/receptions" />}
      />
      <Route
        path="/facturation/factures"
        element={<ProtectedRoute component={FacturationSectionArchivesPage} featureRoute="/facturation/factures" />}
      />
      <Route
        path="/facturation/bons-livraison"
        element={<ProtectedRoute component={FacturationSectionArchivesPage} featureRoute="/facturation/bons-livraison" />}
      />
      <Route
        path="/facturation/bordereaux-retour"
        element={<ProtectedRoute component={FacturationSectionArchivesPage} featureRoute="/facturation/bordereaux-retour" />}
      />
      <Route
        path="/facturation/avoirs-vente-achats"
        element={<ProtectedRoute component={FacturationSectionArchivesPage} featureRoute="/facturation/avoirs-vente-achats" />}
      />
      <Route
        path="/facturation/justificatifs-reglement"
        element={<ProtectedRoute component={FacturationSectionArchivesPage} featureRoute="/facturation/justificatifs-reglement" />}
      />

      {/* Management Features */}
      <Route 
        path="/departments" 
        element={<ProtectedRoute component={DepartmentsPage} featureRoute="/departments" />} 
      />
      
      <Route 
        path="/reports/*" 
        element={<ProtectedRoute component={AnalysesRapportsFacturation} featureRoute="/reports" />} 
      />
      
      <Route 
        path="/warehouses" 
        element={<ProtectedRoute component={WarehousesPage} featureRoute="/stock" />} 
      />

      <Route 
        path="/valorisation" 
        element={<ProtectedRoute component={ValuationPage} featureRoute="/inventaire" />} 
      />
      <Route 
        path="/mouvements-stock" 
        element={<ProtectedRoute component={MouvementsStockPage} featureRoute="/inventaire" />} 
      />
      <Route 
        path="/transferts" 
        element={<ProtectedRoute component={TransfertsPage} featureRoute="/inventaire" />} 
      />
      <Route 
        path="/ajustements" 
        element={<ProtectedRoute component={AjustementsPage} featureRoute="/inventaire" />} 
      />

      {/* REMOVED: /advanced-reports - Deleted from Inventaire */}
      {/* REMOVED: /advanced-analytics - Deleted from Inventaire */}
      {/* REMOVED: /orders - Moved to Achats/Ventes modules */}
      
      <Route 
        path="/timetracking/*" 
        element={<ProtectedRoute component={TimeTrackingMainPage} featureRoute="/time-tracking" />} 
      />
      
      {/* Pointage Module Routes */}
      <Route 
        path="/pointage/demandes-conges" 
        element={<ProtectedRoute component={DemandesCongesPage} featureRoute="/time-tracking" />} 
      />
      <Route 
        path="/pointage/horaires-travail" 
        element={<ProtectedRoute component={HorairesTravailPage} featureRoute="/time-tracking" />} 
      />
      <Route 
        path="/pointage/calendrier-feries" 
        element={<ProtectedRoute component={CalendrierFeriesPage} featureRoute="/time-tracking" />} 
      />
      <Route 
        path="/pointage/justificatifs" 
        element={<ProtectedRoute component={JustificatifsPage} featureRoute="/time-tracking" />} 
      />
      <Route 
        path="/pointage/recuperations" 
        element={<ProtectedRoute component={RecuperationsPage} featureRoute="/time-tracking" />} 
      />
      <Route 
        path="/pointage/profils-horaires" 
        element={<ProtectedRoute component={ProfilsHorairesPage} featureRoute="/time-tracking" />} 
      />
      <Route 
        path="/pointage/zones-travail" 
        element={<ProtectedRoute component={ZonesTravailPage} featureRoute="/time-tracking" />} 
      />
      <Route 
        path="/pointage/affectations-equipes" 
        element={<ProtectedRoute component={AffectationsEquipesPage} featureRoute="/time-tracking" />} 
      />
      
      <Route 
        path="/salaries/*" 
        element={<ProtectedRoute component={SalariesMainPage} featureRoute="/salaries" />} 
      />
      
      {/* Treasury module - Dashboard and all sub-routes */}
      <Route 
        path="/treasury/*" 
        element={<ProtectedRoute component={TreasuryMainPage} featureRoute="/treasury" />} 
      />
      
      <Route 
        path="/banking/*" 
        element={<ProtectedRoute component={BankingMainPage} featureRoute="/banking" />} 
      />
      
      <Route 
        path="/crm/*" 
        element={<ProtectedRoute component={CrmMainPage} featureRoute="/crm" />} 
      />

      {/* Situation Routes — legacy redirects to Comptabilité */}
      <Route path="/situation" element={<Navigate to="/comptabilite/entries" replace />} />
      <Route path="/situation/bilan" element={<Navigate to="/comptabilite/bilan" replace />} />
      <Route path="/situation/resultat" element={<Navigate to="/comptabilite/compte-resultat" replace />} />
      <Route path="/situation/flux" element={<Navigate to="/comptabilite/flux" replace />} />
      <Route path="/situation/balance" element={<Navigate to="/comptabilite/balance-generale" replace />} />
      <Route path="/situation/grand-livre" element={<Navigate to="/comptabilite/grand-livre" replace />} />
      <Route path="/situation/journal" element={<Navigate to="/comptabilite/journal" replace />} />
      <Route path="/situation/annexes" element={<Navigate to="/comptabilite/annexes" replace />} />
      <Route path="/situation/rapports" element={<Navigate to="/comptabilite/rapports" replace />} />
      <Route path="/situation/cloture" element={<Navigate to="/comptabilite/cloture" replace />} />
      <Route path="/situation/comparatifs" element={<Navigate to="/comptabilite/comparatifs" replace />} />
      <Route path="/situation/config" element={<Navigate to="/comptabilite/situation-config" replace />} />

      <Route
        path="/approbations/*"
        element={<ProtectedRoute component={ApprobationsMainPage} featureRoute="/approbations" />}
      />

      <Route
        path="/employee-portal/*"
        element={<ProtectedRoute component={EmployeePortalMainPage} featureRoute="/employee-portal" />}
      />
      
      <Route 
        path="/hr/*" 
        element={
          <HRProvider>
            <ProtectedRoute component={HrMainPage} featureRoute="/employees-management" />
          </HRProvider>
        } 
      />
      <Route path="/hr/departures" element={<ProtectedRoute component={DepartsPage} featureRoute="/hr" />} />
      <Route path="/hr/sanctions" element={<ProtectedRoute component={SanctionsPage} featureRoute="/hr" />} />
      <Route path="/hr/accidents" element={<ProtectedRoute component={AccidentsPage} featureRoute="/hr" />} />

      {/* Saudi ERP — placeholder sections (مواصفات ERP السعودية) */}
      <Route path="/saudi/pending/:moduleId/:sectionId" element={<SaudiPlaceholderPage />} />

      {/* System routes - available in all versions */}
      <Route path="/settings" element={<Settings />} />
      <Route path="/settings/users" element={<Settings />} />
      <Route path="/profile" element={<Profile />} />
      
      {/* Reset routes */}
      <Route path="/reset" element={<ResetDataPage />} />
      <Route path="/reset-setup" element={<ResetSetupPage />} />
      
      {/* Fallback for unknown routes */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};

// Helper components for reset functionality
const ResetDataPage = () => {
  const [resetComplete, setResetComplete] = useState(false);
  
  const handleReset = () => {
    // Import resetSampleData function
    import('../../shared/utils/resetDocuments').then(({ resetSampleData }) => {
      resetSampleData();
      setResetComplete(true);
    });
  };
  
  if (resetComplete) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-750 to-slate-900 flex items-center justify-center">
        <div className="bg-white/10 backdrop-blur-lg p-8 rounded-xl shadow-lg flex flex-col items-center max-w-md w-full">
          <h2 className="text-2xl font-bold text-white mb-4">إعادة تعيين البيانات</h2>
          <p className="text-white/80 mb-4">تمت إعادة تعيين البيانات بنجاح. سيتم إعادة تحميل الصفحة...</p>
        </div>
      </div>
    );
  }
  
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900 flex items-center justify-center">
      <div className="bg-white/10 backdrop-blur-lg p-8 rounded-xl shadow-lg flex flex-col items-center max-w-md w-full">
        <h2 className="text-2xl font-bold text-white mb-4">إعادة تعيين البيانات</h2>
        <p className="text-white/80 mb-4">سيؤدي هذا الإجراء إلى إعادة تعيين جميع بيانات التطبيق مع أمثلة محددة مسبقاً.</p>
        <p className="text-white/80 mb-6">سيتم فقد جميع التعديلات.</p>
        <button 
          onClick={handleReset} 
          className="bg-danger-600 hover:bg-danger-700 text-white px-4 py-2 rounded-lg font-medium transition-colors"
        >
          إعادة تعيين البيانات
        </button>
      </div>
    </div>
  );
};

const ResetSetupPage = () => {
  useEffect(() => {
    console.log("Resetting setup process...");
    
    // Clear all setup-related localStorage items
    localStorage.removeItem('setup_completed');
    localStorage.removeItem('qawaem-settings');
    localStorage.removeItem('qawaem_user');
    localStorage.removeItem('qawaem_default_credentials');
    localStorage.removeItem('qawaem_token');
    localStorage.removeItem('facit_initialized');
    localStorage.removeItem('prevent_sample_data');
    
    // Clear all data to force fresh start
    localStorage.clear();
    
    // Force reload to the setup page
    console.log("Redirecting to setup page...");
    setTimeout(() => {
      window.location.href = '#/setup';
    }, 1000);
  }, []);
  
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900 flex items-center justify-center">
      <div className="bg-white/10 backdrop-blur-lg p-8 rounded-xl shadow-lg flex flex-col items-center">
        <div className="w-16 h-16 border-4 border-t-blue-500 border-blue-500/20 rounded-full animate-spin mb-4"></div>
        <p className="text-white text-lg">إعادة تعيين الإعدادات...</p>
        <p className="text-white/60 text-sm mt-2">إعادة التوجيه إلى معالج الإعداد...</p>
      </div>
    </div>
  );
};

export default FeatureAwareRouter;


